import axios from "axios";
import { store } from "../store";

const domain = "https://api.pickapp2.falksson.de";
const picklistPath = "/api/v1/picklist/";
const startPickPath = "/api/v1/picklist/start/";
const endPickPath = "/api/v1/picklist/end/";
const takeOverPath = "/api/v1/picklist/takeover/";
const fullPickFinishPath = "/api/v1/picklist/item/";
const picklistResetPath = "/api/v1/picklist/reset/";
const missingCountsPath = "/api/v1/picklist/item/missed";

export default {

  picklist() {
    const storedUser = localStorage.getItem("user");
    const currentUser = storedUser ? JSON.parse(storedUser) : null;
    if (currentUser && currentUser.authdata) {
      const url = domain + picklistPath;
      return fetch(url, {
        headers: {
          Authorization: "Basic " + currentUser.authdata,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        credentials: "include"
      })
        .then(response => {
          if (response.ok) return response.json();
        })
        .then(response => {
          if(response) {
            const picklist = response.data || [];
            store.dispatch("setPicklist", picklist);
          }
        });
    }
  },

  picklistDetails(id) {
    const storedUser = localStorage.getItem("user");
    const currentUser = storedUser ? JSON.parse(storedUser) : null;
    return new Promise((resolve, reject) => {
      if (currentUser && currentUser.authdata) {
        const url = domain + picklistPath + id;
        return fetch(url, {
          headers: {
            Authorization: "Basic " + currentUser.authdata,
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          credentials: "include"
        })
          .then(response => {
            if (response.ok) return response.json();
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(e => {
            reject();
          });
      }
    });
  },

  resetPicklist(id) {
    const url = domain + picklistResetPath + id;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };
    return new Promise((resolve, reject) => {
      axios
        .put(url, {}, {
          headers,
          withCredentials: true
        })
        .then(_response => {
          resolve(_response);
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },

  takeOver(id) {
    const url = domain + takeOverPath + id;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };
    return new Promise((resolve, reject) => {
      axios
        .put(url, {}, {
          headers,
          withCredentials: true
        })
        .then(_response => {
          resolve(_response);
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },

  endPick(id) {
    console.log("endPick id: " + id);
    const url = domain + endPickPath + id;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };
    return new Promise((resolve, reject) => {
      axios
        .put(url, {}, {
          headers,
          withCredentials: true
        })
        .then(_response => {
          resolve(_response);
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },

  finishFullPick(pickedList) {
    console.log("call finishFullPick");
    const url = domain + fullPickFinishPath;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };
    return new Promise((resolve, reject) => {
      axios
        .put(url, pickedList, {
          headers,
          withCredentials: true
        })
        .then(_response => {
          resolve(_response.data.data);
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },

  startPick(pixiId) {
    const url = domain + startPickPath + pixiId;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };
    return new Promise((resolve, reject) => {
      axios
        .post(url, {}, {
          headers,
          withCredentials: true
        })
        .then(_response => {
          resolve(_response.data.data);
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },

  missingCounts() {
    const storedUser = localStorage.getItem("user");
    const currentUser = storedUser ? JSON.parse(storedUser) : null;
    if (currentUser && currentUser.authdata) {
      const url = domain + missingCountsPath;
      return fetch(url, {
        headers: {
          Authorization: "Basic " + currentUser.authdata,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        credentials: "include"
      })
      .then(response => {
        if (response.ok) return response.json();
      })
      .then(response => {
        const missingCounts = response.data;
        store.dispatch("setMissingCounts", missingCounts);
      })
      .catch(() => {
        store.dispatch("setMissingCounts", []);
      });
    }
  }
};